interface UIState {
  isLoading: boolean
  error: string | null
}

const initialState: UIState = {
  isLoading: false,
  error: null
}

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    default:
      return state
  }
}

export default reducer
